@import './theme.css';
@import '../../node_modules/tailwindcss/base.css';
@import '../../node_modules/@pandiafi/design-system/lib/index.css';
@import '../../node_modules/tailwindcss/components.css';
@import '../../node_modules/tailwindcss/utilities.css';

/* The resident app card already spaces its content from the top, so the
  first form field inside the page frame does not add a label margin. Uses the
  design system's --form-label-top-margin instead of overriding its markup. */
#resident-app-main form > :first-child {
  --form-label-top-margin: 0;
}
